import { useContext } from 'react';
import { MagicSearchContext } from '@contexts/magic-search/magic-search-context';

export const useMagicSearch = () => useContext(MagicSearchContext);
